import { css } from "@emotion/core";
import { color, fonts, fontSizes } from "../../theme/Theme";

export const documentsStyles = css({
  ".document-header": {
    color: color.secondary,
    fontFamily: fonts.bold,
    fontSize: fontSizes.cardLabel
  },
  ".ant-card": {
    boxShadow: `0 0.25rem 0.625rem 0 ${color.boxShadow}`,
    marginBottom: "1.5rem",
    borderRadius: "0.5rem"
  }
});

export const tableScroll = { y: "60vh", x: "max-content" };
